import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationResultModel } from 'src/app/models/confirmation-result.model';

@Component({
  selector: 'app-confirm-training-participation-modal',
  templateUrl: './confirm-training-participation-modal.component.html',
  styleUrl: './confirm-training-participation-modal.component.scss',
  standalone: false
})
export class ConfirmTrainingParticipationModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  
  @Input() confirmationResultModel!: ConfirmationResultModel;

  get popupWidth(): number | string {
    return window.innerWidth < 576 ? '90vw' : 510;
  }

  constructor(
    private router: Router,
  ) {
    
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);

    this.router.navigate(['/']);
  }
}
